import { render } from "./SurveyScaleQuestion.vue?vue&type=template&id=4faf12eb&scoped=true"
import script from "./SurveyScaleQuestion.vue?vue&type=script&lang=js"
export * from "./SurveyScaleQuestion.vue?vue&type=script&lang=js"

import "./SurveyScaleQuestion.vue?vue&type=style&index=0&id=4faf12eb&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faf12eb"]])

export default __exports__